import { getPlans } from "api/accounts"
import { useQuery } from "react-query"
import { Plan } from "sharedTypes"

const usePlans = () => {
  const { isLoading, data: plans = [] } = useQuery(
    "plans",
    () => getPlans().then(({ data }) => data as Plan[]),
    { staleTime: Infinity },
  )

  return { isLoading, plans }
}

export default usePlans
